module.exports = __webpack_public_path__ + "img/longdevs.9f593265.jpg";